import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Dropdown from 'components/dropdown';
import FeedbackPicker from 'components/feedback/feedback_picker';
import { HorizontalThreeDotsIcon, ReactionSmileIcon, ReplyIcon } from '@seedlang/icons';
import SoftButton from 'components/button/soft_button';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: ${props => props.topRight ? 'absolute' : 'relative'};
  top: ${props => props.topRight ? '-10px' : null};
  right: ${props => props.topRight ? props.topRightRight : null};
  margin-top: 10px;
  margin-right: ${props => props.topRight ? 0 : '10px'};
  @media only screen and (min-width : 650px) and (hover: hover) and (pointer: fine) {
    opacity: ${props => props.topRight ? 0 : 1};
    pointer-events: ${props => props.topRight ? 'none' : 'auto'};
    transition: opacity 0.12s ease-in-out;
  }
`;

const IconBar = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: visible;
`;

export const CommentActionButton = styled(SoftButton)`
  height: 30px;
  margin: 0;
  padding: 0;
  width: 32px;
  .reply-icon {
    width: 16px;
    svg {
      width: 16px;
    }
  }
  .smile-icon {
    width: 13px;
  }
  .reaction-smile-icon {
    width: 18px;
  }
  .horizontal-three-dots-icon {
    height: 5px;
    width: 16px;
  }
  .reply-icon, .smile-icon, .reaction-smile-icon, .horizontal-three-dots-icon {
    fill: #525252;
  }
`;

const MenuItems = styled.ul`
  min-width: ${props => props.dropdownWidth};
  .icon-wrapper {
    > div {
      width: 14px;
    }
    svg {
      width: 14px;
      height: 14px;
    }
  }
  .delete-button-outer-wrapper,
  .delete-button-wrapper {
    display: block;
    width: 100%;
  }
`;

export const AdminMenuItem = ({ background, className, color, style, ...props }) => (
  <li
    {...props}
    className={['on-click', className].filter(item => item).join(' ')}
    style={{
      ...style,
      '--dropdown-item-background': background,
      '--dropdown-item-color': color,
    }}
  />
);

@observer
class CommentReaction extends React.Component {
  render() {
    const adminItems = (this.props.adminItems || []).filter(item => item);
    if (!this.props.showReply && !this.props.showFeedback && adminItems.length === 0 && !this.props.children) {
      return null;
    }
    const feedbackArrowPositionRight = '43px';
    const dropdownWidth = this.props.dropdownWidth || (adminItems.some(item => ['auto-hide', 'seen-by-admin'].includes(item.key)) ? '165px' : '145px');

    return (
      <Wrapper
        className='comment-reaction'
        topRight={this.props.topRight}
        topRightRight={this.props.topRightRight || '20px'}
      >
        <IconBar>
          {
            this.props.showReply &&
              <CommentActionButton
                onClick={this.props.onReply}
                title='Reply'
                type='button'
              >
                <ReplyIcon />
              </CommentActionButton>
          }
          {
            this.props.showFeedback &&
              <CommentActionButton
                onClick={this.props.onToggleFeedback}
                title='Add Reaction'
                type='button'
              >
                <ReactionSmileIcon />
              </CommentActionButton>
          }
          {this.props.children}
          {
            adminItems.length > 0 &&
              <Dropdown
                backgroundOnHover={this.props.backgroundOnHover}
                closeOnDropdownClick
                dropdownWidth={dropdownWidth}
                showOnClick
                textAlign='left'
                top='32px'
                right='0'
              >
                <CommentActionButton
                  title='More'
                  type='button'
                >
                  <HorizontalThreeDotsIcon />
                </CommentActionButton>
                <MenuItems dropdownWidth={dropdownWidth}>
                  {adminItems}
                </MenuItems>
              </Dropdown>
          }
        </IconBar>
        {
          this.props.expandFeedback &&
            <FeedbackPicker
              arrowBoxBottom={null}
              arrowBoxLeft={null}
              arrowBoxRight='0'
              arrowBoxTop='37px'
              arrowPosition='top'
              arrowPositionRight={feedbackArrowPositionRight}
              boxShadow='0px 2px 7px rgba(0, 0, 0, 0.25)'
              onClose={this.props.onToggleFeedback}
              onClick={this.props.onClickFeedback}
            />
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(CommentReaction);
